import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'detailCharts',
    label: 'Detail Charts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
